module.exports = __webpack_public_path__ + "static/34-160f6d43dbb1c3805552b0ac603de8bf.mp4";